import React from "react";

export default class SelectMenu extends React.Component {
    constructor() {
        super();
        this.selectedIndex = -1;
        this.state = {
            menuVisible: false,
            selected: false
        };
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.onOverlayClick = this.onOverlayClick.bind(this);
        // console.log("constructor fired$$$");
    }

    showMenu() {
        var menuVisible = !this.state.menuVisible;
        this.setState({ menuVisible });
    }

    handleSelect(data, i) {
        if (data) {
            var selected = data[this.props.vl];
            this.selectedIndex = i;
            if (this.props.onSelect)
                this.props.onSelect(data);
            //this.state.menuVisible = false;
            this.refs.selectDiv.focus();
            this.setState({ selected, menuVisible: false });
        }
    }

    handleKeyDown(e) {
        if (e.keyCode === 40) {
            //this is for down arrow
            this.selectedIndex = this.selectedIndex < this.props.data.length - 1 ? ++this.selectedIndex : 0;
            this.handleSelect(this.props.data[this.selectedIndex], this.selectedIndex);
            e.preventDefault();
        }
        if (e.keyCode === 38) {
            //this is up arrow
            this.selectedIndex = this.selectedIndex <= 0 ? this.props.data.length - 1 : --this.selectedIndex;
            this.handleSelect(this.props.data[this.selectedIndex], this.selectedIndex);
            e.preventDefault();
        }
    }

    handleBlur() {
        // console.log("handleBlur fired", this.selectedIndex);
        if (typeof this.props.onBlur === "function") {
            // console.log(this.state.menuVisible);
            if (this.selectedIndex === -1) {
                this.props.onBlur();
            }
        }
    }
    onOverlayClick() {
        //console.log("overlay clicked selectedIndex", this.selectedIndex);
        this.setState({ menuVisible: false });

    }

    componentWillReceiveProps(nextProps) {
        //console.log("component will receive props fired", this.props, nextProps);
        if (nextProps.reset) {
            this.selectedIndex = -1;
            this.state = {
                menuVisible: false,
                selected: false
            };
        }
    }



    propValidate() {
        if (this.props.onSelect !== "function")
            throw new Error("selectMenu must have a onSelect prop that must be a function");
        if (!this.props.ky || !this.props.vl)
            throw new Error("selectMenu must have ky prop and vl prop for key and value respectivly");
    }

    render() {
        // console.log("select menu render called");
        var myLi = this.props.data.map((data, i) => {
            return (<li onClick={this.handleSelect.bind(this, data, i)} key={data[this.props.ky]}>{data[this.props.vl]}</li>);
        });
        return (
            <div className="selectMenuHolder"  >
                <div onKeyDown={this.handleKeyDown} tabIndex={this.props.tabIndex} ref="selectDiv" onClick={this.showMenu.bind(this)}
                    className="selectMenu formControl" onBlur={this.handleBlur} style={this.props.style}>
                    <p>{this.state.selected ? this.state.selected : this.props.defaultValue ? this.props.defaultValue : this.props.text || "Select"} <i className="fa fa-caret-down"
                        style={{ float: "right", fontSize: "16px", lineHeight: "24px" }}
                    ></i>
                    </p>
                </div>
                {<ul style={Object.assign({}, this.props.listStyle, { display: this.state.menuVisible ? "block" : "none" })}>
                    {myLi}
                </ul>}



                {this.state.menuVisible ? <div onClick={this.onOverlayClick} className="tOverlay"></div> : null}
            </div>
        );
    }

    componentDidMount() {
        // this is to check if a rex prop is supplied so that it could be foused;
        if (typeof this.props.rex === "function") {
            this.props.rex(this.refs.selectDiv);
        }


    }
}









// WEBPACK FOOTER //
// ./src/jsx/components/utility/select-menu.jsx